import { useContext, useEffect, useState } from "react";
import { userProfileData } from "../../Common/profileInfo";
import { CompleteProfileForm } from "../../queries/CompleteProfileForm";
import ReferralClientEnrolmentContext from "./referral-ots-client-enrolment-context";
import { clientConfig, SetS3Config } from "../../awsClientConfig";
import { useNavigate } from "react-router-dom";
import { Auth, Storage } from "aws-amplify";
import { Box, Button, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faPrint } from "@fortawesome/free-solid-svg-icons";
import { PurchaseProtectionPlan } from "../../queries/PurchaseProtectionPlan";
import { GetLatestFormsByProfile } from "../../queries/GetLatestFormsByProfile";

const SignServiceAgreementForm = () => {
  const { next, nextFormId, enrollmentId, s3key, s3Bucket, previous, isTaxInfoFormSigned, setIsTaxInfoFormSigned } =
    useContext(ReferralClientEnrolmentContext);
  const [irsForm, setIRSForm] = useState("");
  const client = new clientConfig();
  const [spinner, setSpinner] = useState(false);
  const navigate = useNavigate();
  const [isPDF, setIsPDF] = useState<boolean>(!nextFormId);

  useEffect(() => {
    const init = async () => {
      try {
        if (isTaxInfoFormSigned || !nextFormId) {
          await fetchSubmittedForms();
        } else {
          await fetchIRSForm();
        }
      } catch (err) {
        console.error("Error during init agreement logic:", err);
      }
    };
    init();
  }, [nextFormId]);

  const fetchSubmittedForms = async () => {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: true });
      const partnerId = await userProfileData();
      const res: any = await client.query({
        query: GetLatestFormsByProfile,
        variables: { ProfileId: partnerId },
      });
      const forms = res?.data?.GetLatestFormsByProfile || [];
      const taxInfoAgreement = forms?.find((item: any) => item?.Name === "Form8821");
      if (taxInfoAgreement?.S3Key) {
        SetS3Config(taxInfoAgreement?.S3Bucket, "public");
        const fileUrl = await Storage.get(taxInfoAgreement.S3Key, {
          customPrefix: { public: "" },
          contentType: "application/pdf",
        });
        setIsPDF(true);
        setIRSForm(fileUrl);
      }
    } catch (error) {
      console.error("fetchSubmittedForms error:", error);
    }
  };

  const fetchIRSForm = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const irsForm = await Storage.get(s3key, {
        customPrefix: { public: "" },
        level: "public",
        contentType: "image/png",
      });
      setIRSForm(irsForm);
    } catch (error) {
      console.log("error", error);
    }
  };

  const printImage = () => {
    window.print();
  };
  const download = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const Agreement: any = await Storage.get(s3key, {
        customPrefix: { public: "" },
        download: true,
        level: "public",
        contentType: "image/png",
      });
      console.log(Agreement);
      downloadBlob(Agreement.Body, "Form 8821");
    } catch (error) {
      console.log("error", error);
    }
  };

  function downloadBlob(blob: any, filename: any) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  const submitAuth = async () => {
    setSpinner(true);
    const profileId = await userProfileData();
    const variables = {
      ProfileId: profileId,
      FormId: nextFormId,
      EnrollmentId: enrollmentId,
    };

    client
      .mutate({ mutation: CompleteProfileForm, variables: variables })
      .then((res: any) => {
        if (res.data.CompleteProfileForm) {
          setSpinner(false);
          setIsTaxInfoFormSigned(true);
          //next();
          handlePaymentToken();
        }
      })
      .catch((error: any) => {
        setSpinner(false);
      });
  };

  const handlePaymentToken = () => {
    const variables = {
      EnrollmentId: enrollmentId,
    };
    client
      .mutate({ mutation: PurchaseProtectionPlan, variables: variables })
      .then((res: any) => {
        if (res.data.PurchaseProtectionPlan.Id) {
            next();
        }
      })
      .catch((error: any) => {
        console.log(error)
      });
  };

  return (
    <Box
      sx={{
        alignItems: "flex-center",
        p: { xs: 2, md: 6, lg: 4 },
        m: { xs: 2, md: 6, lg: 4 },
      }}
    >
      <Box
        sx={{
          alignItems: "flex-center",
          pl: { xs: 2, md: 6, lg: 4 },
          pr: { xs: 2, md: 6, lg: 4 },
        }}
      >
        <Button
          variant="text"
          sx={{ color: "#212636", p: 0 }}
          onClick={previous}
        >
          {" "}
          <ArrowBack fontSize="small" /> Back
        </Button>
        <Typography variant="h5" sx={{ mt: 2 }}>
          Tax Information Authorization (Form 8821)
        </Typography>
      </Box>

      <Box
        sx={{
          p: 3,
          m: 2,
          mt: 2,
          border: "1px solid var(--mui-palette-divider)",
          borderRadius: 1,
        }}
      >
        <div className="text-end mt-1 mb-1">
          <span className="letsdolater" onClick={printImage}>
            <FontAwesomeIcon className="" icon={faPrint} /> Print
          </span>
          <span
            className="letsdolater"
            style={{ marginLeft: "10px" }}
            onClick={download}
          >
            <FontAwesomeIcon className="" icon={faArrowDown} /> Download
          </span>
        </div>
        <div>
          {isPDF ? (
            <iframe
              src={irsForm}
              className="mt-2 mb-2"
              style={{
                height: "100vh",
                width: "100%",
                overflow: "auto",
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "20px",
            }}
            />
          ) : (
            <div>
              <img
                className="section-to-print"
                id={"irsForm"}
                src={irsForm}
                height="100%"
                width="100%"
                alt="Form**21"
              />
            </div>
          )}
        </div>
        <Box className="d-flex justify-content-end mt-2">
          <Button className="me-2 text-button">Cancel</Button>
          <Button
            onClick={submitAuth}
            disabled={spinner}
            className="option-primary-button"
          >
            {isPDF ? "Continue" : "Click to Sign and Date"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SignServiceAgreementForm;
